import IntegrationRepository from "@/repositories/vns/IntegrationRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'integration',
    namespaced: true,
    state: {
        ...makeState(),
        types: [],
        equipments: [],
        linkIntegrations: []
    },
    getters: {
        ...makeGetters(),
        types (state) {
            return state.types
        },
        equipments (state) {
            return state.equipments
        },
        linkIntegrations (state) {
            return state.linkIntegrations
        },
    },
    mutations: {
        ...makeMutations(),
        setTypes (state, array) {
            state.types = array
        },
        setEquipments (state, array) {
            state.equipments = array
        },
        setLinkIntegrations (state, array) {
            state.linkIntegrations = array
        }
    },
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await IntegrationRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.integration)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit, state }, params) {
            commit('setLoading', true)
            await IntegrationRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.integrations)
                if (response.data.data.meta && Object.keys(response.data.data.meta).length > 0){
                    commit('setPagination', response.data.data.meta)
                }
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await IntegrationRepository.search(params).then(response => {
                if (response.data.data.integrations.length > 0){
                    const array = response.data.data.integrations
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        },
        async searchLink ({ commit }, params) {
            commit('setLoading', true)
            await IntegrationRepository.search({...params, integration_type: 'Link'}).then(response => {
                commit('setLinkIntegrations', response.data.data.integrations || [])
            })
            commit('setLoading', false)
        },
        async listTypes ({ commit }, params) {
            await IntegrationRepository.fetchTypes(params).then(response => {
                commit('setTypes', response.data.data.integrationTypes)
            })
        },
        async listEquipments ({ commit }, params) {
            await IntegrationRepository.fetchEquipments(params).then(response => {
                if (Array.isArray(response.data))
                    commit('setEquipments', response.data)

                commit('setEquipments', [])
            })
        }
    }
}
